import { CartographyResource } from './cartography-resource';
import { computed, Signal, WritableSignal } from '@angular/core';
import { AoSharedTools } from '../../engine/tools/ao-shared-tools';

export class CartographyResourceSite extends CartographyResource {
  public override isValidLatLng = computed(() => {
    return this.geofence()
      .latLng.map((l) => AoSharedTools.isValidLatLng(l.lat(), l.lng()))
      .every((l) => l === true);
  });
  public color: string;
  public geofence: WritableSignal<{
    id: string;
    latLng: google.maps.LatLng[];
    radius: number;
    type: 'circle' | 'polygon';
  }>;
  public circleOptions: Signal<google.maps.CircleOptions> = computed(() => {
    return {
      center: this.geofence().latLng[0],
      clickable: true,
      draggable: false,
      editable: false,
      fillColor: this.color,
      fillOpacity: 0.5,
      radius: this.geofence().radius,
      strokeColor: this.color,
      strokeOpacity: 1,
      strokePosition: google.maps.StrokePosition.CENTER,
      strokeWeight: 2,
      visible: true,
      zIndex: 1,
    };
  });
  public polygonOptions: Signal<google.maps.PolygonOptions> = computed(() => {
    return {
      clickable: true,
      draggable: false,
      editable: false,
      fillColor: this.color,
      fillOpacity: 0.5,
      geodesic: true,
      paths: this.geofence().latLng,
      strokeColor: this.color,
      strokeOpacity: 1,
      strokePosition: google.maps.StrokePosition.CENTER,
      strokeWeight: 2,
      visible: true,
      zIndex: 1,
    };
  });

  public getType(): 'circle' | 'polygon' {
    if (this.geofence().latLng.length === 1) {
      return 'circle';
    }
    return 'polygon';
  }

  public getColor(): string {
    if (this.getType() === 'circle') {
      return this.circleOptions().fillColor;
    }
    return this.polygonOptions().fillColor;
  }

  public getCenter(): google.maps.LatLng {
    if (this.getType() === 'circle') {
      return this.geofence().latLng.at(0);
    }
    const lat =
      this.geofence()
        .latLng.map((latLng) => latLng.lat())
        .reduce((acc, value) => acc + value) / this.geofence().latLng.length;
    const lng =
      this.geofence()
        .latLng.map((latLng) => latLng.lng())
        .reduce((acc, value) => acc + value) / this.geofence().latLng.length;
    return new google.maps.LatLng(lat, lng);
  }

  public isInside(coordinates: google.maps.LatLng): boolean {
    if (!this.isValidLatLng()) {
      return false;
    }
    // Circle
    if (this.getType() === 'circle') {
      const distance = google.maps.geometry.spherical.computeDistanceBetween(
        this.getCenter(),
        coordinates,
      );
      return distance < this.circleOptions().radius;
    }
    if (this.getType() === 'polygon') {
      const polygon = new google.maps.Polygon({
        paths: this.polygonOptions().paths,
      });
      return google.maps.geometry.poly.containsLocation(coordinates, polygon);
    }
    return false;
  }
}
